<template>
    <div class="popup-background">
        <div class="popup">
            <div class="popup__title">
                <h1>{{title}}</h1>
                <h1 v-if="title_2 != ''">{{title2}}</h1>
            </div>
            <div class="popup__body">
                <p id="paragraph" :class="{'cancel-legal-paragraph' : title_2}">{{text}}</p>
                <div class="form-group" v-if="input" :class="{ 'input-error': inputInvalid }">
                    <input class="form-control form-control-lg" type="password" :placeholder="placeholder" :value="inputValue" @input="emitValue($event)"/>
                    <labelInfo v-if="inputInvalid" type="error" :message="inputInvalidText"/>
                </div>
                <div class="form-group" v-if="textarea">
                    <textarea class="form-control form-control-lg" :placeholder="placeholder" :value="inputValue" @input="emitValue($event)"></textarea>
                </div>
            </div>
            <div class="popup__footer" :class="{'cancel-legal-popup' : title_2}">
                <button v-if="cancel != ''" class="button-normal button-normal--cancel" @click="$emit('canceled')">{{cancelButton}}</button>
                <button v-if="confirm != ''" class="button-normal button-normal--media" @click="$emit('confirmed')">{{confirmButton}}</button>
            </div>
        </div>
    </div>
</template>

<script>

import labelInfo from '@/components/blocks/labelInfo.vue'

export default {

    name: 'popup',
    props:{

        title: '',
        title2: '',
        text: '',
        cancelButton: '',
        confirmButton: '',
        input: false,
        placeholder: '',
        inputValue:'',
        inputInvalid:false,
        inputInvalidText: '',
        textarea: false,

    },
    components:{

    labelInfo,

  },
    data(){

        return{

            title_2:  [this.title2],
            cancel: [this.cancelButton],
            confirm: [this.confirmButton],

        }

    },
    methods:{

        emitValue(e){

            this.$emit('input', e.target.value)

        },

        boldString(){

            let paragraph = document.getElementById('paragraph');
            let bolded;
            let re = new RegExp('kar finansowych', 'g');
            bolded = this.text.replace(re, '<b style="font-weight: 700">kar finansowych</b>');

            paragraph.innerHTML = bolded

        }

    },
    mounted(){
        this.boldString()
    }

}
</script>

<style lang="scss" scoped>

.popup-background{
    position:fixed;
    display:flex;
    justify-content: center;
    align-items: center;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background: rgba(172, 172, 172, 0.411);
    z-index: 2000;
}

.popup{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:70vw;
    padding:20px;
    z-index: 1000;
    background:#fff;
    border:1px solid red;

    & h1 {
        text-align: center;
        font-weight: 700;
        margin-bottom: 2rem;

        &:nth-child(1){
            color:rgb(255, 177, 177);
        }
    }

    & .form-group{
        display:flex;
        justify-content: center;
        margin:3rem 0rem;

        & input{
         width:30%;
        }
    }

    &__footer{
        display:flex;
        width:100%;
        justify-content: space-around;
        padding: 10px 0px;
    }
}

.popup__body .allert-icon{
    margin-top:25px;
    margin-left:-10px;
}

.cancel-legal-popup{
    flex-direction: column;
    width: 20%;

    & button{
        height:50px;
        width: 100%;

        &:nth-child(1){
            margin-bottom: 10px;
        }
    }
}

.cancel-legal-paragraph{
    text-align:center;
}

</style>
